<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        <i class="fa fa-user-circle mr-2 text-secondary"></i>
        Change Status
    </ng-container>

    <ng-container dialog-process-in-progress>
        <ng-container *ngIf="!hasClientStatusError; else clientErrorInfoContainer">
            <form [formGroup]="form.formGroup" class="py-3 card-form" autocomplete="off">
                <app-radio-group
                    [panelClass]="'account-statuses'"
                    [formControlName]="form.controls[0].name"
                    [control]="form.controls[0]"
                ></app-radio-group>
                <app-panel-input
                    [formControlName]="form.controls[1].name"
                    [control]="form.controls[1]"
                ></app-panel-input>
            </form>
        </ng-container>
        <ng-template #clientErrorInfoContainer>
            <div class="d-flex mb-4 justify-content-center">
                <i class="fa fa-2x fa-info-circle text-primary d-flex align-items-center"></i>
                <span class="ml-2 text-justify" [innerHTML]="config.process.failedMessage|sanitizeHtml"></span>
            </div>
            <ng-container *ngIf="formErrorCode === (formErrorCodesEnum.CantFindTradingClient|toNumber)">
                <div #addAccountButtonWrap>
                    <div
                        appCheckPermissionRule

                        [rule]="data.accountDependencyPermissionRule"

                        class="row justify-content-center"
                    >
                        <button (click)="dialogRef.close(false)" class="btn btn-primary">Ok</button>
                    </div>
                </div>
                <div
                    *ngIf="addAccountButtonWrap.innerText === ''"

                    class="row justify-content-center"
                >
                    <span class="text-center">{{additionalPermissionsMessage}}</span>
                </div>
            </ng-container>
        </ng-template>
    </ng-container>
</app-dialog>

